import React from 'react'
import { render, screen } from '@testing-library/react'
import EntryCard from '../EntryCard'

describe('Entry Card Tests', () => {
  it('Should Render EntryCard', () => {
    render(
      <EntryCard
        ctaLabel='CTA Label'
        ctaLink='/'
        image={[
          {
            url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/events/_768x576_crop_center-center_82_line/food-for-thought.jpg',
            title: ''
          }
        ]}
        linkIcons='arrow'
        sectionDescription='Entry Card description'
        sectionHeading='Entry Card heading'
      />
    )
    expect(screen.getByTestId('entry-card')).toBeTruthy()
  })
})
